import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function EditBrokerSharing({
  open,
  onClose,
  user,
  master,
  fetchUsers,
}) {
  const [newValue, setNewValue] = useState("");
  const [newValue1, setNewValue1] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const max_sharing = Number(master?.sharing ?? 0);
  const max_sharing_intrest = Number(master?.deposit_interest_rate ?? 0);

  useEffect(() => {
    if (open) {
      setNewValue(String(user?.bb_sharing ?? ""));
      setNewValue1(String(user?.bb_interest_sharing ?? ""));
    }
  }, [open, user]);

  // ONE CLEAN INPUT HANDLER
  const handleNumberInput = (value, setter) => {
    // Allow only numbers + decimals
    value = value.replace(/[^0-9.]/g, "");

    // Only one dot
    if ((value.match(/\./g) || []).length > 1) return;

    // Only 2 decimals
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;

    setter(value);
  };

  const handleSave = useCallback(async () => {
    if (isLoading) return;

    if (!newValue) {
      toast.error("Sharing cannot be empty");
      return;
    }

    if (user.nse_cash === 1 && !newValue1) {
      toast.error("Interest Sharing cannot be empty");
      return;
    }

    const num = parseFloat(newValue);
    const num1 = parseFloat(newValue1 || 0);

    if (isNaN(num)) {
      toast.error("Please enter valid sharing value");
      return;
    }

    if (user.nse_cash === 1 && isNaN(num1)) {
      toast.error("Please enter valid interest sharing value");
      return;
    }

    if (num < 0 || num > max_sharing) {
      toast.error(`Sharing must be between 0 and ${max_sharing}%`);
      return;
    }

    if (user.nse_cash === 1 && (num1 < 0 || num1 > max_sharing_intrest)) {
      toast.error(`Interest must be between 0 and ${max_sharing_intrest}%`);
      return;
    }

    setIsLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: user.id,
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username"),
      sharing: num,
      sharing_interest: num1,
    };

    try {
      const response = await backend.edit_broker_sharing(payload);
      if (response.error === "False") {
        toast.success(response.message);
        fetchUsers?.();
        onClose?.();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Network error, please try again");
    } finally {
      setIsLoading(false);
    }
  }, [newValue, newValue1, isLoading]);

  const handleRemove = useCallback(async () => {
    if (isLoading) return;
    setIsLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: user.id,
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username")
    };

    try {
      const response = await backend.remove_broker(payload);
      if (response.error === "False") {
        toast.success(response.message);
        fetchUsers?.();
        onClose?.();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Network error, please try again");
    } finally {
      setIsLoading(false);
    }
  }, [newValue, newValue1, isLoading]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
      <div className="bg-[var(--background)] border-2 border-[var(--hover)] rounded-xl shadow-lg w-[90%] max-w-md p-6">
        <h2 className="text-lg font-bold text-[var(--text)]">
          ✏️ Edit Sharing (%)
        </h2>

        {/* SHARING INPUT */}
        <input
          type="text"
          inputMode="decimal"
          value={newValue}
          onChange={(e) => handleNumberInput(e.target.value, setNewValue)}
          className="mt-4 w-full border border-[var(--hover)] bg-[var(--background)] text-[var(--text)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-[var(--primary)]"
          placeholder={`Max ${max_sharing}%`}
        />
        <div className="p-2 text-sm font-semibold text-[var(--text)]">
          Max Sharing : {max_sharing}%
        </div>

        {/* INTEREST SHARING ONLY IF NSE CASH ENABLED */}
        {user.nse_cash === 1 && (
          <>
            <input
              type="text"
              inputMode="decimal"
              value={newValue1}
              onChange={(e) => handleNumberInput(e.target.value, setNewValue1)}
              className="mt-4 w-full border border-[var(--hover)] bg-[var(--background)] text-[var(--text)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-2 focus:ring-[var(--primary)]"
              placeholder={`Max ${max_sharing_intrest}%`}
            />
            <div className="p-2 text-sm font-semibold text-[var(--text)]">
              Max Interest Sharing : {max_sharing_intrest}%
            </div>
          </>
        )}

        <div className="flex justify-end gap-5 mt-6">
          <button
            onClick={handleRemove}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--sell)] text-[var(--white)] transition mr-10"
            disabled={isLoading}
          >
            Remove Broker
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--sell)] text-[var(--white)] transition"
            disabled={isLoading}
          >
            Cancel
          </button>

          <button
            onClick={handleSave}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-[var(--primary)] text-white transition disabled:opacity-60"
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
